import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UnsavedChangesHostHelper } from '../services/unsaved-changes/unsaved-changes-host.helper';

export const UNSAVED_CHANGES_CONFIRM_TITLE = 'Unsaved Changes';

export const UNSAVED_CHANGES_CONFIRM_MESSAGE =
  'You have unsaved changes. If you leave this page, your changes will be lost. Do you want to discard the changes?';

/**
 * Components that participate in leave confirmation should implement this.
 * Return false / falsy Observable to stay; true to allow navigation.
 */
export interface CanComponentDeactivate {
  canDeactivate(): boolean | Promise<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component
) => {
  if (!component || typeof component.canDeactivate !== 'function') {
    return true;
  }
  return component.canDeactivate();
};

/**
 * Shared confirm used by CanDeactivate and any in-app prompts.
 * @returns `true` when the user chooses Discard Changes; `false` for Stay on Page.
 */
export function confirmDiscardUnsavedChanges(
  dialog: MatDialog
): Promise<boolean> {
  return UnsavedChangesHostHelper.openConfirm(dialog);
}
